<template>
    <div>
        <v-dialog v-model="dialog" max-width="1440px">
            <v-card>
                <v-card-title>
                    <span class="headline"
                        >PACKINGLIST NO : PRPKT18100007 | BOX : 1 :</span
                    >
                </v-card-title>
                <v-card-text>
                    <v-simple-table
                        cellpadding="0"
                        cellspacing="0"
                        style="border: 1px solid"
                        class="table-inv1"
                    >
                        <template v-slot:default style="width: 100%">
                            <tbody>
                                <tr>
                                    <th style="">Type</th>
                                    <th style="">Project</th>
                                    <th style="">CaseID</th>

                                    <th class="">Serial</th>
                                    <th style="">Description</th>
                                    <th class="">Qty</th>
                                    <th class="">Remark</th>
                                    <th class="">Req By</th>
                                    <th class="">Status</th>
                                    <th class="">Remark</th>
                                </tr>
                                <tr style="border: 2px solid">
                                    <td height="100px" align="center">
                                        Document
                                    </td>
                                    <td align="center">FINANCE</td>
                                    <td align="center"></td>

                                    <td align="center">เอกสารFINANCE</td>
                                    <td align="center"></td>
                                    <td>1</td>
                                    <td>BOOKING110475900</td>
                                    <td>MSVC</td>
                                    <td>
                                        <v-select required dense></v-select>
                                    </td>
                                    <td>
                                        <v-text-field
                                            single-line
                                        ></v-text-field>
                                    </td>
                                </tr>
                            </tbody>
                        </template>
                    </v-simple-table>
                </v-card-text>

                <div></div>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" text @click="dialog = false"
                        >Save Receive Packing</v-btn
                    >

                    <v-btn color="blue darken-1" text @click="dialog = false"
                        >Close</v-btn
                    >
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog
            v-model="dialog_search"
            fullscreen
            hide-overlay
            transition="dialog-bottom-transition"
        >
            <v-card>
                <v-toolbar dark color="primary">
                    <v-btn
                        icon
                        dark
                        @click="
                            ;(dialog_search = false),
                                (data_search.date = []),
                                (dateRangeText = []),
                                (data_history = []),
                                (data_search.searchtext = '')
                        "
                    >
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                    <v-toolbar-title>
                        <!-- Settings -->
                    </v-toolbar-title>
                    <v-spacer></v-spacer>
                    <!-- <v-toolbar-items>
                            <v-btn dark text @click="dialog = false"
                                >Save</v-btn
                            >
                        </v-toolbar-items> -->
                </v-toolbar>
                <v-list three-line subheader>
                    <v-list-item>
                        <v-list-item-content>
                            <v-row>
                                <v-col cols="3">
                                    <v-text-field
                                        label="Search"
                                        v-model="data_search.searchtext"
                                        prepend-inner-icon="mdi-magnify"
                                        dense
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="3">
                                    <v-menu
                                        v-model="modal"
                                        :close-on-content-click="false"
                                        :nudge-right="40"
                                        transition="scale-transition"
                                        offset-y
                                    >
                                        <template v-slot:activator="{ on }">
                                            <v-text-field
                                                v-model="dateRangeText"
                                                label="Date range"
                                                dense
                                                prepend-inner-icon="mdi-calendar"
                                                readonly
                                                v-on="on"
                                            ></v-text-field>
                                        </template>
                                        <v-date-picker
                                            v-model="data_search.date"
                                            range
                                            @change="get_date()"
                                        ></v-date-picker>
                                    </v-menu>
                                </v-col>
                                <v-col cols="3" class="text-right">
                                    <v-btn
                                        rounded
                                        small
                                        class="ml-5"
                                        @click="get_history()"
                                        :disabled="
                                            data_search.searchtext == '' &&
                                                data_search.date.length == 0
                                        "
                                    >
                                        <v-icon small class="mr-1">
                                            mdi-magnify
                                        </v-icon>
                                        Search
                                    </v-btn>
                                    <v-btn
                                        color="success"
                                        rounded
                                        small
                                        class="ml-5"
                                        @click="get_history_export()"
                                        :disabled="
                                            data_search.searchtext == '' &&
                                                data_search.date.length == 0
                                        "
                                    >
                                        Export Data
                                    </v-btn>
                                </v-col>
                            </v-row>

                            <v-row>
                                <v-col cols="12">
                                    <v-simple-table class="table-inv">
                                        <template v-slot:default>
                                            <thead>
                                                <tr class="col-tr-1">
                                                    <th class="text-center">
                                                        #
                                                    </th>
                                                    <th class="text-center">
                                                        To/Company
                                                    </th>
                                                    <th class="text-center">
                                                        Packing_no
                                                    </th>
                                                    <th class="text-center">
                                                        Description
                                                    </th>
                                                    <th class="text-center">
                                                        S/N
                                                    </th>
                                                    <th class="text-center">
                                                        Singlepart
                                                    </th>
                                                    <th class="text-center">
                                                        Created
                                                    </th>
                                                    <th class="text-center">
                                                        Packing
                                                    </th>
                                                    <th class="text-center">
                                                        Received
                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr
                                                    v-for="(row,
                                                    index) in data_history.data"
                                                    :key="index"
                                                >
                                                    <td class="text-center">
                                                        {{ index + 1 }}
                                                    </td>
                                                    <td class="text-center">
                                                        {{ row.branch_name }}
                                                        <br />
                                                        {{ row.company }}
                                                    </td>
                                                    <td class="text-center">
                                                        {{ row.packing_no }}
                                                    </td>
                                                    <td class="text-center">
                                                        {{ row.description }}
                                                    </td>
                                                    <td class="text-center">
                                                        {{ row.serial }}
                                                    </td>
                                                    <td>
                                                        {{ row.singlepart }}
                                                    </td>
                                                    <td class="text-center">
                                                        {{ row.created_name }}1
                                                        <br />
                                                        {{ row.created_date }}
                                                    </td>
                                                    <td>
                                                        {{ row.packing_name }}
                                                        <br />
                                                        {{ row.packing_date }}
                                                    </td>

                                                    <td class="text-center">
                                                        {{ row.received_name }}
                                                        <br />
                                                        {{ row.received_date }}
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </template>
                                    </v-simple-table>
                                    <div
                                        class="text-center pb-5 pt-4"
                                        v-if="data_history != ''"
                                    >
                                        <div>
                                            <v-btn
                                                class="mx-2"
                                                fab
                                                small
                                                @click="backhistory()"
                                            >
                                                <v-icon dark small
                                                    >mdi-chevron-left</v-icon
                                                >
                                            </v-btn>

                                            <v-btn
                                                class="mx-2"
                                                fab
                                                small
                                                :color="btn_colorhistory(n)"
                                                v-for="n in page_counthistory"
                                                :key="n"
                                                @click="
                                                    gethistory(
                                                        page_num_showhistory(n)
                                                    )
                                                "
                                                >{{
                                                    page_num_showhistory(n)
                                                }}</v-btn
                                            >

                                            <v-btn
                                                class="mx-2"
                                                fab
                                                small
                                                @click="nexthistory()"
                                            >
                                                <v-icon dark small
                                                    >mdi-chevron-right</v-icon
                                                >
                                            </v-btn>
                                        </div>
                                    </div>
                                </v-col>
                            </v-row>
                        </v-list-item-content>
                    </v-list-item>
                </v-list>
            </v-card>
        </v-dialog>

        <v-dialog persistent v-model="dialogform" max-width="1440px">
            <v-toolbar dense dark color="primary">
                <v-btn icon dark @click="dialogform = false">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
                <v-toolbar-title>{{
                    edit == "0" ? "CREATE NEW ITEM" : "EDIT ITEM"
                }}</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-toolbar-items>
                    <v-btn
                        v-if="edit == '0'"
                        dark
                        text
                        @click="
                            savepackingrequest(add_newitems.length),
                                (dialogform = false)
                        "
                        :disabled="!valid"
                    >
                        <v-icon left>mdi-content-save</v-icon>
                        Save
                    </v-btn>
                    <v-btn
                        v-else
                        dark
                        text
                        @click="editpackingrequest(), (dialogform = false)"
                    >
                        <v-icon left>mdi-content-save</v-icon>
                        Save Edit
                    </v-btn>
                </v-toolbar-items>
            </v-toolbar>
            <v-card>
                <v-card-text>
                    <v-container fluid>
                        <v-form method="post" id="nativeForm" v-model="valid">
                            <v-simple-table
                                class="table-inv"
                                cellpadding="0"
                                cellspacing="0"
                            >
                                <thead>
                                    <tr class="col-tr-1">
                                        <th
                                            width="23%"
                                            v-if="
                                                team_name !== 'SVC' &&
                                                    role_name != 'Admin Hub'
                                            "
                                            class="text-center white--text"
                                        >
                                            SITE
                                        </th>
                                        <th
                                            width="23%"
                                            class="text-center white--text"
                                            v-if="
                                                team_name == 'SVC' ||
                                                    team_name == 'ONSITE' ||
                                                    (team_name == 'SUPPORTUC' &&
                                                        role_name ==
                                                            'Admin Hub')
                                            "
                                        >
                                            TO TEAM
                                        </th>
                                        <th
                                            width="15%"
                                            class="text-center white--text"
                                        >
                                            TYPE
                                        </th>
                                        <th class="text-center white--text">
                                            DESCRIPTION
                                        </th>
                                        <th
                                            width="15%"
                                            class="text-center white--text"
                                        >
                                            COMPANY
                                        </th>
                                        <th width="5%" v-if="edit != '1'"></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr
                                        v-for="(add_newitem, i) in add_newitems"
                                        :key="i"
                                    >
                                        <td
                                            v-if="
                                                team_name !== 'SVC' &&
                                                    role_name !== 'Admin Hub'
                                            "
                                        >
                                            <v-select
                                                class="pt-4"
                                                v-model="add_newitem.branch"
                                                :items="databranch"
                                                item-text="branch_name"
                                                item-value="branch_id"
                                                :rules="nottosite"
                                                required
                                                outlined
                                                dense
                                                multiple
                                                :disabled="
                                                    edit == '0' ? false : true
                                                "
                                            >
                                                <template
                                                    v-slot:selection="{
                                                        item,
                                                        index,
                                                    }"
                                                >
                                                    <v-chip v-if="index === 0">
                                                        <span>{{
                                                            item.branch_name
                                                        }}</span>
                                                    </v-chip>
                                                    <span
                                                        v-if="index === 1"
                                                        class="grey--text caption"
                                                        >(+{{
                                                            add_newitem.branch
                                                                .length - 1
                                                        }}
                                                        others)</span
                                                    >
                                                </template>
                                                <template v-slot:prepend-item>
                                                    <v-list-item
                                                        ripple
                                                        @click="toggle(i)"
                                                    >
                                                        <v-list-item-action>
                                                            <v-icon
                                                                :color="
                                                                    add_newitem
                                                                        .branch
                                                                        .length >
                                                                    0
                                                                        ? 'indigo darken-4'
                                                                        : ''
                                                                "
                                                                >{{
                                                                    add_newitem.icon
                                                                }}</v-icon
                                                            >
                                                        </v-list-item-action>
                                                        <v-list-item-content>
                                                            <v-list-item-title>
                                                                Select All
                                                            </v-list-item-title>
                                                        </v-list-item-content>
                                                    </v-list-item>
                                                    <v-divider
                                                        class="mt-2"
                                                    ></v-divider>
                                                </template>
                                            </v-select>
                                        </td>

                                        <td
                                            v-if="
                                                team_name == 'SVC' ||
                                                    team_name == 'ONSITE' ||
                                                    (team_name == 'SUPPORTUC' &&
                                                        role_name ==
                                                            'Admin Hub')
                                            "
                                        >
                                            <v-select
                                                class="pt-4"
                                                :items="datateam"
                                                item-text="team_name"
                                                item-value="team_id"
                                                :rules="notteam"
                                                required
                                                outlined
                                                dense
                                                v-model="add_newitem.team"
                                            ></v-select>
                                        </td>
                                        <td>
                                            <v-select
                                                class="pt-4"
                                                :items="datatype"
                                                item-text="type_name"
                                                item-value="type_id"
                                                :rules="nottype"
                                                required
                                                outlined
                                                dense
                                                v-model="add_newitem.type"
                                            ></v-select>
                                        </td>
                                        <td>
                                            <v-text-field
                                                class="pt-4"
                                                single-line
                                                outlined
                                                hint="* อธิบายข้างในซองมีอะไร"
                                                :rules="notdescription"
                                                dense
                                                required
                                                v-model="
                                                    add_newitem.description
                                                "
                                            ></v-text-field>
                                        </td>
                                        <td>
                                            <v-select
                                                class="pt-4"
                                                v-model="add_newitem.company"
                                                :items="company"
                                                required
                                                outlined
                                                dense
                                            ></v-select>
                                        </td>
                                        <td v-if="edit != '1'">
                                            <v-btn
                                                v-if="i != 0"
                                                tile
                                                color="secondary"
                                                icon
                                                @click="
                                                    deleteRow(i, add_newitem)
                                                "
                                            >
                                                <v-icon large color="red"
                                                    >mdi-delete-circle</v-icon
                                                >
                                            </v-btn>
                                        </td>
                                    </tr>
                                    <tr v-if="edit == 0">
                                        <td colspan="5" align="center">
                                            <v-btn
                                                v-if="edit == '0'"
                                                class="ma-2"
                                                color="success"
                                                dark
                                                small
                                                @click="addNewRow()"
                                            >
                                                <v-icon left
                                                    >mdi-plus-circle</v-icon
                                                >
                                                Add More Item
                                            </v-btn>
                                        </td>
                                    </tr>
                                </tbody>
                            </v-simple-table>
                        </v-form>
                    </v-container>
                </v-card-text>
            </v-card>
        </v-dialog>
        <v-container fluid>
            <v-row no-gutters>
                <v-col :cols="6">
                    <h1 class="headline font-weight-light mb-3">Logistic</h1>
                </v-col>

                <v-col :cols="6" class="text-right">
                    <v-btn
                        v-if="
                            header != 'headersnonhp' &&
                                project == 'ViewOwnerItem'
                        "
                        color="white"
                        @click="showdialoghistory()"
                        dark
                        small
                        class="mb-2"
                    >
                        <v-icon left color="black">mdi-magnify</v-icon
                        ><label style="color: black">History</label>
                    </v-btn>
                    <v-btn
                        v-if="
                            header != 'headersnonhp' &&
                                project == 'ViewOwnerItem'
                        "
                        color="success"
                        dark
                        small
                        class="mb-2"
                        @click="opendialog()"
                    >
                        <v-icon left>mdi-plus</v-icon>Create New Item
                    </v-btn>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12" sm="6" md="6">
                    <v-text-field
                        v-model="search"
                        append-icon="mdi-magnify"
                        label="Search"
                        @input="activesearch()"
                    ></v-text-field>
                </v-col>
            </v-row>
        </v-container>
        <v-card>
            <v-tabs
                background-color="blue accent-2"
                color="lime accent-2"
                v-model="tab"
                grow
                dark
            >
                <v-tabs-slider></v-tabs-slider>

                <v-tab
                    v-if="
                        team_name == 'SVC' ||
                            team_name == 'INVENTORY' ||
                            team_name == 'ONSITE' ||
                            (team_name == 'SUPPORTUC' &&
                                role_name == 'Admin Hub')
                    "
                    v-for="item in items1"
                    :key="item"
                    @click="getviewpending(item)"
                >
                    {{ item }}
                </v-tab>
                <v-tab
                    v-if="
                        team_name != 'SVC' &&
                            team_name != 'INVENTORY' &&
                            team_name != 'ONSITE' &&
                            role_name != 'Admin Hub'
                    "
                    v-for="item in items2"
                    :key="item"
                    @click="getviewpending(item)"
                >
                    {{ item }}
                </v-tab>

                <v-tabs-items touchless v-model="tab">
                    <v-tab-item v-for="item in items1" :key="item">
                        <v-card v-if="project != '' && tab == 0">
                            <v-simple-table class="table-inv">
                                <template v-slot:default>
                                    <thead>
                                        <tr class="col-tr-1">
                                            <th
                                                width="15%"
                                                class="text-center white--text"
                                            >
                                                TO
                                            </th>
                                            <th
                                                width="40%"
                                                class="text-center white--text"
                                            >
                                                DESCRIPTION
                                            </th>
                                            <th class="text-center white--text">
                                                S/N
                                            </th>
                                            <th class="text-center white--text">
                                                SINGLEPART
                                            </th>
                                            <th
                                                width="10%"
                                                class="text-center white--text"
                                            >
                                                STATUS
                                            </th>
                                            <th
                                                width="15%"
                                                class="text-center white--text"
                                            >
                                                SENT
                                            </th>
                                            <th
                                                width="15%"
                                                class="text-center white--text"
                                            >
                                                RECEIVED
                                            </th>
                                            <th
                                                width="7%"
                                                class="text-center white--text"
                                            ></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr
                                            v-for="(items, idx) in data.data"
                                            :key="idx"
                                        >
                                            <td>
                                                {{ items.branch_name }}
                                                {{ items.team_name }}
                                            </td>
                                            <td>{{ items.description }}</td>
                                            <td>{{ items.serial }}</td>
                                            <td>{{ items.singlepart }}</td>
                                            <td class="text-center">
                                                {{ items.status }}
                                            </td>
                                            <td class="text-center">
                                                <label
                                                    >{{ items.created_date }}
                                                </label>
                                            </td>
                                            <td class="text-center">
                                                <label>
                                                    {{ items.received_date }}
                                                </label>
                                            </td>
                                            <td class="text-center">
                                                <v-icon
                                                    v-if="
                                                        items.status ==
                                                            'Pending'
                                                    "
                                                    small
                                                    class="mr-2"
                                                    @click="editItem(items)"
                                                    >mdi-square-edit-outline</v-icon
                                                >
                                                <v-icon
                                                    small
                                                    @click="deleteItem(items)"
                                                    >mdi-delete</v-icon
                                                >
                                            </td>
                                        </tr>
                                    </tbody>
                                </template>
                            </v-simple-table>
                            <div class="text-center pb-5 pt-4">
                                <div>
                                    <v-btn
                                        class="mx-2"
                                        fab
                                        small
                                        @click="back()"
                                    >
                                        <v-icon dark small
                                            >mdi-chevron-left</v-icon
                                        >
                                    </v-btn>

                                    <v-btn
                                        class="mx-2"
                                        fab
                                        small
                                        :color="btn_color(n)"
                                        v-for="n in page_count"
                                        :key="n"
                                        @click="getpage(page_num_show(n))"
                                        >{{ page_num_show(n) }}</v-btn
                                    >

                                    <v-btn
                                        class="mx-2"
                                        fab
                                        small
                                        @click="next()"
                                    >
                                        <v-icon dark small
                                            >mdi-chevron-right</v-icon
                                        >
                                    </v-btn>
                                </div>
                            </div>
                        </v-card>
                        <v-card
                            v-if="
                                project != '' &&
                                    tab == 1 &&
                                    (team_name == 'SVC' ||
                                        team_name == 'INVENTORY' ||
                                        team_name == 'ONSITE' ||
                                        (team_name == 'SUPPORTUC' &&
                                            role_name == 'Admin Hub'))
                            "
                        >
                            <v-simple-table class="table-inv">
                                <template v-slot:default>
                                    <thead>
                                        <tr class="col-tr-1">
                                            <th class="text-center white--text">
                                                #
                                            </th>
                                            <th class="text-center white--text">
                                                Packing No
                                            </th>
                                            <th class="text-center white--text">
                                                From / To
                                            </th>
                                            <th class="text-center white--text">
                                                Status
                                            </th>
                                            <th class="text-center white--text">
                                                Consignment No / Total Box /
                                                Total Items
                                            </th>
                                            <th class="text-center white--text">
                                                Packing By / Date
                                            </th>
                                            <th class="text-center white--text">
                                                Received By / Date
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr
                                            v-for="(row,
                                            index) in dataviewpending.data"
                                            :key="index"
                                        >
                                            <td class="text-center">
                                                {{ index + 1 }}
                                            </td>
                                            <td class="text-center">
                                                {{ row.packing_no
                                                }}<v-btn
                                                    class="mx-2"
                                                    fab
                                                    dark
                                                    x-small
                                                    color="black"
                                                    @click="
                                                        showdetailpending(row)
                                                    "
                                                >
                                                    <v-icon
                                                        >mdi-wrap-disabled</v-icon
                                                    >
                                                </v-btn>
                                            </td>
                                            <td>
                                                <b>From : </b
                                                >{{ row.from_branch_name
                                                }}<br />
                                                <b>To : </b
                                                >{{ row.to_branch_name }}
                                            </td>

                                            <td class="text-center">
                                                {{ row.status }}
                                            </td>
                                            <td
                                                class="text-center"
                                                v-if="row.packing"
                                            >
                                                <b>consignment no : </b
                                                >{{ row.consignment_no }} <br />
                                                <b>Box : </b
                                                >{{ row.total_box }} /
                                                <b
                                                    >items :
                                                    {{ row.packing.length }}</b
                                                >
                                            </td>
                                            <td class="text-center">
                                                <span
                                                    v-if="
                                                        row.team_received_name !=
                                                            null
                                                    "
                                                >
                                                    {{ row.team_received_name }}
                                                    <br />
                                                    ({{
                                                        row.team_received_date
                                                    }})
                                                </span>
                                            </td>
                                            <td class="text-center">
                                                <span
                                                    v-if="
                                                        row.received_name !=
                                                            null
                                                    "
                                                >
                                                    {{ row.received_name }}
                                                    <br />
                                                    ({{ row.received_date }})
                                                </span>
                                            </td>
                                        </tr>
                                    </tbody>
                                </template>
                            </v-simple-table>
                            <div class="text-center pb-5 pt-4">
                                <div>
                                    <v-btn
                                        class="mx-2"
                                        fab
                                        small
                                        @click="backreceive()"
                                    >
                                        <v-icon dark small
                                            >mdi-chevron-left</v-icon
                                        >
                                    </v-btn>

                                    <v-btn
                                        class="mx-2"
                                        fab
                                        small
                                        :color="btn_colorreceivepacking(n)"
                                        v-for="n in page_countreceivepacking"
                                        :key="n"
                                        @click="
                                            getpagereceivepacking(
                                                page_num_showreceivepacking(n)
                                            )
                                        "
                                        >{{
                                            page_num_showreceivepacking(n)
                                        }}</v-btn
                                    >

                                    <v-btn
                                        class="mx-2"
                                        fab
                                        small
                                        @click="nextreceive()"
                                    >
                                        <v-icon dark small
                                            >mdi-chevron-right</v-icon
                                        >
                                    </v-btn>
                                </div>
                            </div>
                        </v-card>

                        <v-card
                            v-if="
                                project != '' &&
                                    tab == 1 &&
                                    team_name != 'SVC' &&
                                    team_name != 'ONSITE' &&
                                    team_name != 'INVENTORY' &&
                                    role_name != 'Admin Hub'
                            "
                        >
                            <v-simple-table class="table-inv">
                                <template v-slot:default>
                                    <thead>
                                        <tr class="col-tr-1">
                                            <th
                                                width="3%"
                                                class="text-center white--text"
                                            >
                                                #
                                            </th>
                                            <th class="text-center white--text">
                                                Packing No
                                            </th>
                                            <th class="text-center white--text">
                                                Description
                                            </th>
                                            <th class="text-center white--text">
                                                Status
                                            </th>
                                            <th class="text-center white--text">
                                                Packing By / Date
                                            </th>
                                            <th class="text-center white--text">
                                                Team Received By / Date
                                            </th>
                                            <th class="text-center white--text">
                                                Action
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr
                                            v-for="(row,
                                            index) in dataviewpending.data"
                                            :key="index"
                                        >
                                            <td class="text-center">
                                                {{ index + 1 }}
                                            </td>
                                            <td class="text-center">
                                                {{ row.packing_no }}
                                            </td>
                                            <td>{{ row.description }}</td>
                                            <td class="text-center">
                                                {{ row.status }}
                                            </td>
                                            <td class="text-center">
                                                <span
                                                    v-if="
                                                        row.packing_name != null
                                                    "
                                                >
                                                    {{ row.packing_name }}
                                                    <br />
                                                    ({{ row.packing_date }})
                                                </span>
                                            </td>
                                            <td class="text-center">
                                                <span
                                                    v-if="
                                                        row.team_received_name !=
                                                            null
                                                    "
                                                >
                                                    {{ row.team_received_name }}
                                                    <br />
                                                    ({{
                                                        row.team_received_date
                                                    }})
                                                </span>
                                            </td>
                                            <td class="text-center">
                                                <v-card-title>
                                                    <v-row>
                                                        <v-btn
                                                            class="ma-2"
                                                            rounded
                                                            dark
                                                            v-if="
                                                                row.team_received_name ==
                                                                    null
                                                            "
                                                            @click="
                                                                receiveitem(
                                                                    row.detail_id
                                                                )
                                                            "
                                                            color="grey"
                                                            style="
                                                                font-size: 10px;
                                                            "
                                                        >
                                                            <v-icon left
                                                                >mdi-check-box-outline</v-icon
                                                            >
                                                            Receive
                                                        </v-btn>
                                                    </v-row>
                                                </v-card-title>
                                            </td>
                                        </tr>
                                    </tbody>
                                </template>
                            </v-simple-table>
                            <div class="text-center pb-5 pt-4">
                                <div>
                                    <v-btn
                                        class="mx-2"
                                        fab
                                        small
                                        @click="backreceive()"
                                    >
                                        <v-icon dark small
                                            >mdi-chevron-left</v-icon
                                        >
                                    </v-btn>

                                    <v-btn
                                        class="mx-2"
                                        fab
                                        small
                                        :color="btn_colorreceiveitem(n)"
                                        v-for="n in page_countreceiveitem"
                                        :key="n"
                                        @click="
                                            getpagereceiveitem(
                                                page_num_showreceiveitem(n)
                                            )
                                        "
                                        >{{
                                            page_num_showreceiveitem(n)
                                        }}</v-btn
                                    >

                                    <v-btn
                                        class="mx-2"
                                        fab
                                        small
                                        @click="nextreceive()"
                                    >
                                        <v-icon dark small
                                            >mdi-chevron-right</v-icon
                                        >
                                    </v-btn>
                                </div>
                            </div>
                        </v-card>
                        <v-card
                            v-if="
                                project != '' &&
                                    tab == 2 &&
                                    (team_name == 'SVC' ||
                                        team_name == 'ONSITE' ||
                                        team_name == 'INVENTORY' ||
                                        (team_name == 'SUPPORTUC' &&
                                            role_name == 'Admin Hub'))
                            "
                        >
                            <v-simple-table class="table-inv">
                                <template v-slot:default>
                                    <thead>
                                        <tr class="col-tr-1">
                                            <th class="text-center white--text">
                                                #
                                            </th>
                                            <th class="text-center white--text">
                                                Packing No
                                            </th>
                                            <th class="text-center white--text">
                                                From / To
                                            </th>
                                            <th class="text-center white--text">
                                                Status
                                            </th>
                                            <th class="text-center white--text">
                                                Consignment No / Total Box /
                                                Total items
                                            </th>
                                            <th class="text-center white--text">
                                                Packing By / Date
                                            </th>
                                            <th class="text-center white--text">
                                                Received By / Date
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr
                                            v-for="(row,
                                            index) in dataviewpending.data"
                                            :key="index"
                                        >
                                            <td class="text-center">
                                                {{ index + 1 }}
                                            </td>
                                            <td class="text-center">
                                                {{ row.packing_no
                                                }}<v-btn
                                                    class="mx-2"
                                                    fab
                                                    dark
                                                    x-small
                                                    color="black"
                                                    @click="
                                                        showdetailpending(
                                                            row,
                                                            'sent'
                                                        )
                                                    "
                                                >
                                                    <v-icon
                                                        >mdi-wrap-disabled</v-icon
                                                    >
                                                </v-btn>
                                            </td>
                                            <td>
                                                <b>From : </b
                                                >{{ row.from_branch_name
                                                }}<br />
                                                <b>To : </b
                                                >{{ row.to_branch_name }}
                                            </td>

                                            <td class="text-center">
                                                {{ row.status }}
                                            </td>
                                            <td
                                                class="text-center"
                                                v-if="row.packing"
                                            >
                                                <b>consignment no : </b
                                                >{{ row.consignment_no }} <br />
                                                <b>Box : </b
                                                >{{ row.total_box }} /
                                                <b
                                                    >items :
                                                    {{ row.packing.length }}</b
                                                >
                                            </td>
                                            <td class="text-center">
                                                <span
                                                    v-if="
                                                        row.packing_name != null
                                                    "
                                                >
                                                    {{ row.packing_name }}
                                                    <br />
                                                    ({{ row.packing_date }})
                                                </span>
                                            </td>
                                            <td class="text-center">
                                                <span
                                                    v-if="
                                                        row.received_name !=
                                                            null
                                                    "
                                                >
                                                    {{ row.received_name }}
                                                    <br />
                                                    ({{ row.received_date }})
                                                </span>
                                            </td>
                                        </tr>
                                    </tbody>
                                </template>
                            </v-simple-table>
                            <div class="text-center pb-5 pt-4">
                                <div>
                                    <v-btn
                                        class="mx-2"
                                        fab
                                        small
                                        @click="backsentpacking()"
                                    >
                                        <v-icon dark small
                                            >mdi-chevron-left</v-icon
                                        >
                                    </v-btn>

                                    <v-btn
                                        class="mx-2"
                                        fab
                                        small
                                        :color="btn_colorsentpacking(n)"
                                        v-for="n in page_countsentpacking"
                                        :key="n"
                                        @click="
                                            getpagesentpacking(
                                                page_num_showsentpacking(n)
                                            )
                                        "
                                        >{{
                                            page_num_showsentpacking(n)
                                        }}</v-btn
                                    >

                                    <v-btn
                                        class="mx-2"
                                        fab
                                        small
                                        @click="nextsentpacking()"
                                    >
                                        <v-icon dark small
                                            >mdi-chevron-right</v-icon
                                        >
                                    </v-btn>
                                </div>
                            </div>
                        </v-card>
                    </v-tab-item>
                </v-tabs-items>
            </v-tabs>
        </v-card>

        <template>
            <v-form method="post" id="nativeForm" v-model="validreceive">
                <v-row justify="center">
                    <v-dialog v-model="dialogreceive" max-width="1280px">
                        <v-card>
                            <v-card-title>
                                <v-row>
                                    <v-col cols="12" md="4">
                                        Packing No :
                                        {{ datashowdetailpending.packing_no }}
                                    </v-col>

                                    <v-col cols="12" md="4">
                                        <span
                                            >Consignment No :
                                            {{
                                                datashowdetailpending.consignment_no
                                            }}</span
                                        >
                                    </v-col>

                                    <v-col cols="12" md="4">
                                        <span
                                            >Total Box :
                                            {{
                                                datashowdetailpending.total_box
                                            }}</span
                                        >
                                    </v-col>

                                    <v-col cols="12" md="4">
                                        <span
                                            >From :
                                            {{
                                                datashowdetailpending.from_branch_name
                                            }}</span
                                        >
                                    </v-col>

                                    <v-col cols="12" md="4">
                                        <span
                                            >To :
                                            {{
                                                datashowdetailpending.to_branch_name
                                            }}</span
                                        >
                                    </v-col>

                                    <v-col
                                        v-if="
                                            datashowdetailpending.status !=
                                                'Received' &&
                                                datasentstatus != 'sent'
                                        "
                                        cols="12"
                                        sm="12"
                                        md="12"
                                    >
                                        <span class="headline">
                                            <!-- savereceivepartnonhp(
                                                        datashowdetailpending,
                                                        'ReceivePacking'
                                                    ) -->
                                            <v-btn
                                                class="ma-2"
                                                :disabled="!validreceive"
                                                @click="
                                                    savereceivepartnonhp_2(
                                                        datashowdetailpending
                                                    )
                                                "
                                                color="cyan"
                                                style="color: white"
                                            >
                                                <v-icon left color="white"
                                                    >mdi-content-save</v-icon
                                                >
                                                Save
                                            </v-btn>
                                        </span>
                                    </v-col>
                                </v-row>
                            </v-card-title>

                            <v-container style="margin-top: -30px"
                                ><v-row>
                                    <v-col cols="12">
                                        <v-simple-table class="table-inv">
                                            <template v-slot:default>
                                                <thead>
                                                    <tr class="col-tr-1 np">
                                                        <th class="text-center">
                                                            #
                                                        </th>
                                                        <th class="text-center">
                                                            Type
                                                        </th>
                                                        <th class="text-center">
                                                            CaseID
                                                        </th>
                                                        <th class="text-center">
                                                            S/N
                                                        </th>
                                                        <th class="text-center">
                                                            Singlepart
                                                        </th>
                                                        <th class="text-center">
                                                            Description
                                                        </th>
                                                        <th class="text-center">
                                                            Packing_by/ Date
                                                        </th>
                                                        <th class="text-center">
                                                            Qty
                                                        </th>
                                                        <th
                                                            class="text-center"
                                                            v-if="
                                                                datashowdetailpending.status !=
                                                                    'Received'
                                                            "
                                                        >
                                                            Action
                                                        </th>
                                                        <th
                                                            class="text-center"
                                                            v-else
                                                        >
                                                            Status
                                                        </th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr
                                                        v-for="(row,
                                                        index) in datashowdetailpending.packing"
                                                        :key="index"
                                                    >
                                                        <td class="text-center">
                                                            {{ index + 1 }}
                                                        </td>

                                                        <td class="text-center">
                                                            {{ row.type_name }}
                                                        </td>

                                                        <td class="text-center">
                                                            {{ row.case_id }}
                                                        </td>
                                                        <td class="text-center">
                                                            {{ row.serial }}
                                                        </td>
                                                        <td class="text-center">
                                                            {{ row.singlepart }}
                                                        </td>
                                                        <td class="text-center">
                                                            {{
                                                                row.description
                                                            }}
                                                        </td>
                                                        <td class="text-center">
                                                            {{
                                                                row.created_name
                                                            }}/
                                                            {{
                                                                row.created_date
                                                            }}
                                                        </td>
                                                        <td class="text-center">
                                                            {{ row.qty }}
                                                        </td>
                                                        <td
                                                            class="text-center"
                                                            v-if="
                                                                datashowdetailpending.status !=
                                                                    'Received' &&
                                                                    datasentstatus !=
                                                                        'sent'
                                                            "
                                                        >
                                                            <v-radio-group
                                                                v-model="
                                                                    row.status
                                                                "
                                                                row
                                                            >
                                                                <v-radio
                                                                    label="Received"
                                                                    value="receive"
                                                                ></v-radio>
                                                                <v-radio
                                                                    label="Not Received"
                                                                    value="not_receive"
                                                                ></v-radio>
                                                            </v-radio-group>
                                                            <v-text-field
                                                                v-if="
                                                                    row.status ==
                                                                        'not_receive'
                                                                "
                                                                label="Reason"
                                                                v-model="
                                                                    row.remark
                                                                "
                                                                :rules="reasonR"
                                                                required
                                                            ></v-text-field>
                                                        </td>
                                                        <td
                                                            v-else-if="
                                                                datashowdetailpending.status ==
                                                                    'Sent'
                                                            "
                                                            class="text-center"
                                                        >
                                                            Sent
                                                        </td>
                                                        <td
                                                            v-else
                                                            class="text-center"
                                                        >
                                                            Received
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </template>
                                        </v-simple-table>
                                        <hr class="fix-hr-1" />
                                    </v-col>
                                </v-row>
                            </v-container>
                        </v-card>
                    </v-dialog>
                </v-row>
            </v-form>
        </template>
        <v-data-table
            v-if="header == 'headersviewsentlist'"
            :headers="headersviewsentlist"
            :items="this.data"
            :items-per-page="10"
            :loading="isLoading"
            :search="search"
            loading-text="Loading... Please wait"
        >
            <template v-slot:item.action="{ item }">
                <v-icon small class="mr-2" @click="editItem(item)"
                    >mdi-square-edit-outline</v-icon
                >
                <v-icon small @click="deleteItem(item)">mdi-delete</v-icon>
            </template>
        </v-data-table>

        <v-data-table
            v-if="header == 'headersviewreceivelist'"
            :headers="headersviewreceivelist"
            :items="this.data"
            :items-per-page="10"
            :loading="isLoading"
            :search="search"
            loading-text="Loading... Please wait"
        >
            <template v-slot:item.status="{ item }">
                <v-btn @click="dialog = true" color="#5032321f">
                    <v-avatar left> <v-icon>mdi-truck-check</v-icon> </v-avatar
                    >Receive</v-btn
                >
            </template>
            <template v-slot:item.action="{ item }">
                <v-icon small class="mr-2" @click="editItem(item)"
                    >mdi-square-edit-outline</v-icon
                >
                <v-icon small @click="deleteItem(item)">mdi-delete</v-icon>
            </template>
        </v-data-table>

        <v-dialog v-model="dialog_loading" hide-overlay persistent width="320">
            <v-card color="primary" dark>
                <v-card-text>
                    <span class="mt-1 white--text">Loading</span>
                    <v-progress-linear
                        indeterminate
                        color="white"
                        class="mb-0"
                    ></v-progress-linear>
                </v-card-text>
            </v-card>
        </v-dialog>

        <div id="snackbar">
            <v-snackbar v-model="snackbar" color="success" right>{{
                text
            }}</v-snackbar>
        </div>
    </div>
</template>

<script>
import axios from "axios"
import { mapState, mapMutations } from "vuex"

export default {
    computed: {
        ...mapState(["isLoading"]),
        ...mapState(["snackbar"]),
        dateRangeText() {
            this.data_search.date.sort((a, b) => {
                return new Date(a) - new Date(b)
            })

            return this.data_search.date.join(" ~ ")
        },
    },

    mounted() {
        //เปิดหน้านี้ครั้งแรก จะเข้ามาทำที่ mounted ก่อนเป็นอัมดับแรก
        // เรียกฟังชั้น getAjax
        this.showsummary("ViewOwnerItem")
        // this.getAjax()
        this.getType()
        this.getBranch()
        // this.getProject();
    },
    data() {
        return {
            dialog_loading: false,
            modal: false,
            data_search: {
                searchtext: "",
                date: [],
            },
            dialog_search: false,
            data_history: [],
            datasentstatus: "",
            activetab: "",
            editteam: "",
            search: "",
            datasavereceive: [],
            reasonR: [(v) => !!v || "Reason is required"],
            validreceive: false,
            packingno: "",
            dialogreceive: false,
            datashowdetailpending: [],
            dataviewpending: [],
            dialogform: false,
            page_total: 0,
            page_count: 0,
            page_totalreceiveitem: 0,
            page_countreceiveitem: 0,
            page_totalreceivepacking: 0,
            page_countreceivepacking: 0,
            page_totalsentpacking: 0,
            page_countsentpacking: 0,
            page_totalhistory: 0,
            page_counthistory: 0,
            page: 1,
            num: 1,
            tab: null,
            items1: ["View Owner", "ReceivePacking", "SentPacking"],
            items2: ["View Owner", "ReceiveItem"],
            company: ["ACACIA", "ASERVE"],
            team_name: localStorage.team_name,
            role_name: localStorage.role_name,
            nottosite: [(v) => v.length > 0 || "Site is required"],
            notteam: [(v) => !!v || "Team is required"],
            // notproject: [(v) => !!v || "Project is required"],
            nottype: [(v) => !!v || "Type is required"],
            notdescription: [(v) => !!v || "Description is required"],
            notqty: [(v) => !!v || "Qty is required"],
            valid: false,
            editedIndex: "",
            editedItem: {
                type: "",
                send_to_team: "",
                project: "",
                caseid: "",
                description: "",
                serial: "",
                qty: "",
                remark: "",
                branch: "",
                company: "",
            },
            edit: 0,
            panel: [],
            items: 78,
            datatype: [],
            dataproject: [],
            databranch: [],
            datateam: [],
            dialog: false,
            data: [],
            dataissuetransfer: [],
            project: "",

            stateadd: 0,
            add_newitems: [],
            add_newitems_template: [
                {
                    branch: [],
                    team: "",
                    type: "",
                    description: "",
                    qty: "1",
                    company: "ACACIA",
                    icon: "mdi-checkbox-blank-outline",
                },
            ],

            text: "Success, Log has been saved",

            search: "",

            url: process.env.VUE_APP_ROOT_API,
            header: "",
            headersviewowneritem: [
                {
                    text: "To",
                    value: "branch_name",
                    class: "text-uppercase blue darken-3 white--text",
                },
                {
                    text: "company",
                    value: "company",
                    class: "text-uppercase blue darken-3 white--text",
                },
                {
                    text: "team",
                    value: "team_name",
                    class: "text-uppercase blue darken-3 white--text",
                },
                {
                    text: "Description",
                    value: "description",
                    class: "text-uppercase blue darken-3 white--text",
                },
                // {
                //   text: "Singlepart",
                //   value: "singlepart",
                //   class: "text-uppercase blue darken-3 white--text",
                // },
                // {
                //   text: "S/N",
                //   value: "serial",
                //   class: "text-uppercase blue darken-3 white--text",
                // },
                {
                    text: "Qty",
                    value: "qty",
                    class: "text-uppercase blue darken-3 white--text",
                },
                {
                    text: "Status",
                    value: "status",
                    class: "text-uppercase blue darken-3 white--text",
                },
                {
                    text: "Date Sent",
                    value: "created_at",
                    class: "text-uppercase blue darken-3 white--text",
                },
                {
                    text: "Date Received",
                    value: "datereceived",
                    class: "text-uppercase blue darken-3 white--text",
                },
                {
                    text: "Action",
                    value: "action",
                    class: "text-uppercase blue darken-3 white--text",
                    sortable: false,
                },
            ],
            headersnonhp: [
                {
                    text: "#1",
                    value: "",
                    class: "text-uppercase blue darken-3 white--text",
                },
                {
                    text: "To",
                    value: "",
                    class: "text-uppercase blue darken-3 white--text",
                },

                {
                    text: "Description",
                    value: "",
                    class: "text-uppercase blue darken-3 white--text",
                },

                {
                    text: "Qty",
                    value: "",
                    class: "text-uppercase blue darken-3 white--text",
                },
                {
                    text: "Status",
                    value: "",
                    class: "text-uppercase blue darken-3 white--text",
                },
                {
                    text: "Date Sent",
                    value: "",
                    class: "text-uppercase blue darken-3 white--text",
                },
                {
                    text: "Date Received",
                    value: "",
                    class: "text-uppercase blue darken-3 white--text",
                },
                {
                    text: "Action",
                    value: "action",
                    class: "text-uppercase blue darken-3 white--text",
                    sortable: false,
                },
            ],
            headersviewsentlist: [
                {
                    text: "#",
                    value: "",
                    class: "text-uppercase blue darken-3 white--text",
                },
                {
                    text: "To",
                    value: "",
                    class: "text-uppercase blue darken-3 white--text",
                },
                {
                    text: "PackingID",
                    value: "",
                    class: "text-uppercase blue darken-3 white--text",
                },
                {
                    text: "Sent Date",
                    value: "",
                    class: "text-uppercase blue darken-3 white--text",
                },
                {
                    text: "Box",
                    value: "",
                    class: "text-uppercase blue darken-3 white--text",
                },
                {
                    text: "Bill No",
                    value: "",
                    class: "text-uppercase blue darken-3 white--text",
                },
                {
                    text: "Status",
                    value: "",
                    class: "text-uppercase blue darken-3 white--text",
                },
                {
                    text: "Received Date",
                    value: "",
                    class: "text-uppercase blue darken-3 white--text",
                },
            ],
            headersviewreceivelist: [
                {
                    text: "#",
                    value: "",
                    class: "text-uppercase blue darken-3 white--text",
                },
                {
                    text: "To",
                    value: "",
                    class: "text-uppercase blue darken-3 white--text",
                },
                {
                    text: "PackingID",
                    value: "",
                    class: "text-uppercase blue darken-3 white--text",
                },
                {
                    text: "Sent Date",
                    value: "",
                    class: "text-uppercase blue darken-3 white--text",
                },
                {
                    text: "Box",
                    value: "",
                    class: "text-uppercase blue darken-3 white--text",
                },
                {
                    text: "Bill No",
                    value: "",
                    class: "text-uppercase blue darken-3 white--text",
                },
                {
                    text: "Status",
                    value: "status",
                    class: "text-uppercase blue darken-3 white--text",
                },
                {
                    text: "Received Date",
                    value: "",
                    class: "text-uppercase blue darken-3 white--text",
                },
            ],
        }
    },
    methods: {
        get_date() {
            if (this.dateRangeText.length === 23) {
                this.modal = false
            }
        },
        showdialoghistory() {
            if (this.dialog_search === false) {
                this.dialog_search = true
            } else {
                this.dialog_search = false
            }
        },
        async get_history() {
            // console.log(this.data_search)
            this.dialog_loading = true
            const url = `${process.env.VUE_APP_ROOT_API}/api/logistics/packing-request/history`
            const options = {
                headers: {
                    Authorization: "Bearer " + localStorage.token,
                },
            }
            this.mutateIsLoading()
            await axios
                .post(url, this.data_search, options)
                .then((response) => {
                    // console.log(response, "hhh");
                    this.page_counthistory = 0
                    this.data_history = response.data
                    this.page_totalhistory = response.data.last_page
                    this.page_totalhistory < 7
                        ? (this.page_counthistory = this.page_totalhistory)
                        : (this.page_counthistory = 7)
                    this.mutateIsLoading()
                    this.dialog_loading = false
                })
                .catch((error) => {
                    console.log(error)
                    this.mutateIsLoading()
                })
        },
        async get_history_export() {
            const url = `${process.env.VUE_APP_ROOT_API}/api/logistics/packing-request/history-export`
            this.dialog_loading = true
            await axios({
                url: url,
                method: "POST",
                responseType: "blob",
                data: this.data_search,
                headers: { Authorization: "Bearer " + localStorage.token },
            }).then((response) => {
                // console.log(response)
                let fileURL = window.URL.createObjectURL(
                    new Blob([response.data])
                )
                let fileLink = document.createElement("a")

                fileLink.href = fileURL
                fileLink.setAttribute("download", "report.xlsx")
                document.body.appendChild(fileLink)

                fileLink.click()
                this.dialog_loading = false
            })
        },
        activesearch() {
            if (this.activetab == "Viewowner") {
                this.getAjax()
            } else if (this.activetab == "ReceivePacking") {
                this.getviewpending("ReceivePacking")
            } else if (this.activetab == "ReceiveItem") {
                this.getviewpending("ReceiveItem")
            } else if (this.activetab == "SentPacking") {
                this.getviewpending("SentPacking")
            }
        },
        receiveitem(detail_id) {
            this.$swal({
                title: "Confirm Receive this item ?",
                text: "",
                icon: "warning",
                buttons: true,
                dangerMode: true,
            }).then((del) => {
                if (del) {
                    this.savereceiveitem(detail_id)
                }
            })
        },
        async savereceiveitem(detail_id) {
            const options = {
                headers: {
                    Authorization: "Bearer " + localStorage.token,
                },
            }
            const url = `${process.env.VUE_APP_ROOT_API}/api/logistics/packinglist/receive-team`
            try {
                const { data } = await axios.post(
                    url + "/" + detail_id,
                    {},
                    options
                )
                this.dataviewpending = []
                this.getviewpending("ReceiveItem")
            } catch (error) {
                console.log(error)
            }
        },

        async savereceivepartnonhp(items, statuspart) {
            const options = {
                headers: {
                    Authorization: "Bearer " + localStorage.token,
                },
            }
            for (let i = 0; i < items.packing.length; i++) {
                if (
                    items.packing[i].button == "" ||
                    items.packing[i].button == undefined ||
                    items.packing[i].button == null
                ) {
                    this.$swal(
                        "กรุณาเลือกปุ่ม Receive หรือ NotReceive ",
                        "Please Select Receive or NotReceive",
                        "info"
                    )
                    exit()
                }
            }

            var status = ""
            this.datasavereceive = []
            items.packing.map((each) => {
                if (each.button == 1) {
                    status = "receive"
                } else if (each.button == 2) {
                    status = "not_receive"
                }

                var sent = {
                    detail_id: each.select,
                    status: status,
                    remark: each.remark,
                }
                // var packing = {
                //   packing: sent,
                // };

                this.datasavereceive.push(sent)

                var status = ""
            })
            this.mutateIsLoading()
            const url = `${process.env.VUE_APP_ROOT_API}/api/logistics/packinglist/receive`
            try {
                const { data } = await axios.post(
                    url + "/" + this.packingno,
                    { packing: this.datasavereceive },
                    options
                )
                this.dialogreceive = false
                this.mutateIsLoading()

                this.getviewpending(statuspart)
            } catch (error) {
                console.log(error)
            }
        },

        async savereceivepartnonhp_2(items) {
            // this.mutateIsLoading()

            let send = {
                packingno: items.packingno,
                company: items.company,
                consignment_no: items.consignment_no,
                from_branch: items.from_branch,
                from_branch_name: items.from_branch_name,
                packing: [],
                packing_at: items.packing_at,
                packing_by: items.packing_by,
                packing_date: items.packing_date,
                packing_name: items.company,
                packing_no: items.packing_no,
                qty_issue: items.qty_issue,
                qty_transfer: items.qty_transfer,
                received_at: items.received_at,
                received_by: items.received_by,
                received_date: items.received_date,
                received_name: items.received_name,
                row_num: items.row_num,
                status: items.status,
                to_branch: items.to_branch,
                to_branch_name: items.to_branch_name,
                total_box: items.total_box,
            }
            items.packing.map((each) => {
                if (each.status == "receive" || each.status == "not_receive") {
                    send.packing.push(each)
                }
            })
            // console.log(items)
            // console.log(send)
            this.save_pk(send)
        },
        async save_pk(send) {
            this.dialog_loading = true
            await axios
                .post(
                    `${process.env.VUE_APP_ROOT_API}/api/logistics/packinglist/receive/` +
                        send.packing_no,
                    send,
                    {
                        headers: {
                            Authorization: "Bearer " + localStorage.token,
                        },
                    }
                )
                .then((response) => {
                    this.dialogreceive = false
                    // this.mutateIsLoading()
                    this.dialog_loading = false
                    this.mutatesnackbar()
                    this.getviewpending("ReceivePacking")
                    if (this.snackbar === true) {
                        setTimeout(() => {
                            this.mutatesnackbar()
                        }, 3000)
                    }
                })
        },
        showdetailpending(items, sentdata) {
            // console.log(items, "asdsad");
            this.datasentstatus = ""
            this.dialogreceive = true
            this.packingno = items.packing_no

            this.datashowdetailpending = items
            if (sentdata != undefined) {
                this.datasentstatus = sentdata
            }
            // console.log(items, "sdwe");
        },
        async getviewpending(tab) {
            this.activetab = tab
            if (tab === "ReceivePacking") {
                this.dataviewpending = []
                this.mutateIsLoading()
                const options = {
                    headers: {
                        Authorization: "Bearer " + localStorage.token,
                    },
                }
                const url = `${process.env.VUE_APP_ROOT_API}/api/logistics/packinglist/view-pending`
                try {
                    const { data } = await axios.post(
                        url,
                        { searchtext: this.search },
                        options
                    )
                    this.mutateIsLoading()
                    // console.log(data, "fff")
                    this.dataviewpending = data
                    this.page_totalreceivepacking = data.last_page
                    this.page_totalreceivepacking < 7
                        ? (this.page_countreceivepacking = this.page_totalreceivepacking)
                        : (this.page_countreceivepacking = 7)
                } catch (error) {
                    console.log(error)
                }
            }
            if (tab === "ReceiveItem") {
                this.dataviewpending = []
                this.mutateIsLoading()
                const options = {
                    headers: {
                        Authorization: "Bearer " + localStorage.token,
                    },
                }
                const url = `${process.env.VUE_APP_ROOT_API}/api/logistics/packinglist/view-pending-team`
                try {
                    const { data } = await axios.post(
                        url,
                        { searchtext: this.search },
                        options
                    )

                    // console.log(data, "trtr");
                    this.mutateIsLoading()

                    this.dataviewpending = data
                    this.page_totalreceiveitem = data.last_page
                    this.page_totalreceiveitem < 7
                        ? (this.page_countreceiveitem = this.page_totalreceiveitem)
                        : (this.page_countreceiveitem = 7)
                } catch (error) {
                    console.log(error)
                }
            }
            if (tab === "SentPacking") {
                this.dataviewpending = []
                this.mutateIsLoading()
                const options = {
                    headers: {
                        Authorization: "Bearer " + localStorage.token,
                    },
                }
                const url = `${process.env.VUE_APP_ROOT_API}/api/logistics/packinglist/view-sent`
                try {
                    const { data } = await axios.post(
                        url,
                        { searchtext: this.search },
                        options
                    )

                    // console.log(data, "trtr");
                    this.mutateIsLoading()

                    this.dataviewpending = data
                    this.page_totalsentpacking = data.last_page

                    this.page_totalsentpacking < 7
                        ? (this.page_countsentpacking = this.page_totalsentpacking)
                        : (this.page_countsentpacking = 7)
                } catch (error) {
                    console.log(error)
                }
            }
        },
        async back() {
            const options = {
                headers: {
                    Authorization: "Bearer " + localStorage.token,
                },
            }
            let url = this.data.prev_page_url
            let { data } = await axios.post(url, {}, options)

            this.data = data
        },
        async next() {
            const options = {
                headers: {
                    Authorization: "Bearer " + localStorage.token,
                },
            }
            let url = this.data.next_page_url
            let { data } = await axios.post(url, {}, options)

            this.data = data
        },
        async getpage(num) {
            const options = {
                headers: {
                    Authorization: "Bearer " + localStorage.token,
                },
            }
            if (num != "...") {
                this.current_page = num
                let url =
                    `${process.env.VUE_APP_ROOT_API}/api/logistics/packing-request?page=` +
                    num
                let { data } = await axios.post(url, {}, options)

                this.data = data
            }
        },
        async gethistory(num) {
            const options = {
                headers: {
                    Authorization: "Bearer " + localStorage.token,
                },
            }
            if (num != "...") {
                this.current_page = num
                let url =
                    `${process.env.VUE_APP_ROOT_API}/api/logistics/packing-request/history?page=` +
                    num
                let { data } = await axios.post(url, this.data_search, options)

                this.data_history = data
            }
        },

        async backsentpacking() {
            const options = {
                headers: {
                    Authorization: "Bearer " + localStorage.token,
                },
            }
            let url = this.dataviewpending.prev_page_url
            let { data } = await axios.post(url, {}, options)

            this.dataviewpending = data
        },
        async nextsentpacking() {
            const options = {
                headers: {
                    Authorization: "Bearer " + localStorage.token,
                },
            }
            let url = this.dataviewpending.next_page_url
            let { data } = await axios.post(url, {}, options)

            this.dataviewpending = data
        },
        async backreceive() {
            const options = {
                headers: {
                    Authorization: "Bearer " + localStorage.token,
                },
            }
            let url = this.dataviewpending.prev_page_url
            let { data } = await axios.post(url, {}, options)

            this.dataviewpending = data
        },
        async nextreceive() {
            const options = {
                headers: {
                    Authorization: "Bearer " + localStorage.token,
                },
            }
            let url = this.dataviewpending.next_page_url
            let { data } = await axios.post(url, {}, options)

            this.dataviewpending = data
        },
        async backhistory() {
            const options = {
                headers: {
                    Authorization: "Bearer " + localStorage.token,
                },
            }
            let url = this.data_history.prev_page_url
            let { data } = await axios.post(url, this.data_search, options)

            this.data_history = data
        },
        async nexthistory() {
            const options = {
                headers: {
                    Authorization: "Bearer " + localStorage.token,
                },
            }
            let url = this.data_history.next_page_url
            let { data } = await axios.post(url, this.data_search, options)

            this.data_history = data
        },
        async getpagereceiveitem(num) {
            const options = {
                headers: {
                    Authorization: "Bearer " + localStorage.token,
                },
            }
            if (num != "...") {
                this.current_page = num
                let url =
                    `${process.env.VUE_APP_ROOT_API}/api/logistics/packinglist/view-pending-team?page=` +
                    num
                let { data } = await axios.post(url, {}, options)

                this.dataviewpending = data
            }
        },
        async getpagereceivepacking(num) {
            const options = {
                headers: {
                    Authorization: "Bearer " + localStorage.token,
                },
            }
            if (num != "...") {
                this.current_page = num
                let url =
                    `${process.env.VUE_APP_ROOT_API}/api/logistics/packinglist/view-pending?page=` +
                    num
                let { data } = await axios.post(url, {}, options)

                this.dataviewpending = data
            }
        },
        async getpagesentpacking(num) {
            const options = {
                headers: {
                    Authorization: "Bearer " + localStorage.token,
                },
            }
            if (num != "...") {
                this.current_page = num
                let url =
                    `${process.env.VUE_APP_ROOT_API}/api/logistics/packinglist/view-sent?page=` +
                    num
                let { data } = await axios.post(url, {}, options)

                this.dataviewpending = data
            }
        },
        btn_color(n) {
            if (this.page_count == 7) {
                if (this.data.current_page <= 4) {
                    return this.data.current_page === n ? "primary" : ""
                } else if (this.data.current_page == this.data.last_page) {
                    return n === 7 ? "primary" : ""
                } else if (this.data.current_page == this.data.last_page - 1) {
                    return n === 6 ? "primary" : ""
                } else if (this.data.current_page == this.data.last_page - 2) {
                    return n === 5 ? "primary" : ""
                } else {
                    return n === 4 ? "primary" : ""
                }
            } else {
                return this.data.current_page === n ? "primary" : ""
            }
        },
        btn_colorreceiveitem(n) {
            if (this.page_countreceiveitem == 7) {
                if (this.dataviewpending.current_page <= 4) {
                    return this.dataviewpending.current_page === n
                        ? "primary"
                        : ""
                } else if (
                    this.dataviewpending.current_page ==
                    this.dataviewpending.last_page
                ) {
                    return n === 7 ? "primary" : ""
                } else if (
                    this.dataviewpending.current_page ==
                    this.dataviewpending.last_page - 1
                ) {
                    return n === 6 ? "primary" : ""
                } else if (
                    this.dataviewpending.current_page ==
                    this.dataviewpending.last_page - 2
                ) {
                    return n === 5 ? "primary" : ""
                } else {
                    return n === 4 ? "primary" : ""
                }
            } else {
                return this.dataviewpending.current_page === n ? "primary" : ""
            }
        },
        btn_colorreceivepacking(n) {
            if (this.page_countreceivepacking == 7) {
                if (this.dataviewpending.current_page <= 4) {
                    return this.dataviewpending.current_page === n
                        ? "primary"
                        : ""
                } else if (
                    this.dataviewpending.current_page ==
                    this.dataviewpending.last_page
                ) {
                    return n === 7 ? "primary" : ""
                } else if (
                    this.dataviewpending.current_page ==
                    this.dataviewpending.last_page - 1
                ) {
                    return n === 6 ? "primary" : ""
                } else if (
                    this.dataviewpending.current_page ==
                    this.dataviewpending.last_page - 2
                ) {
                    return n === 5 ? "primary" : ""
                } else {
                    return n === 4 ? "primary" : ""
                }
            } else {
                return this.dataviewpending.current_page === n ? "primary" : ""
            }
        },

        btn_colorsentpacking(n) {
            if (this.page_countsentpacking == 7) {
                if (this.dataviewpending.current_page <= 4) {
                    return this.dataviewpending.current_page === n
                        ? "primary"
                        : ""
                } else if (
                    this.dataviewpending.current_page ==
                    this.dataviewpending.last_page
                ) {
                    return n === 7 ? "primary" : ""
                } else if (
                    this.dataviewpending.current_page ==
                    this.dataviewpending.last_page - 1
                ) {
                    return n === 6 ? "primary" : ""
                } else if (
                    this.dataviewpending.current_page ==
                    this.dataviewpending.last_page - 2
                ) {
                    return n === 5 ? "primary" : ""
                } else {
                    return n === 4 ? "primary" : ""
                }
            } else {
                return this.dataviewpending.current_page === n ? "primary" : ""
            }
        },
        btn_colorhistory(n) {
            if (this.page_counthistory == 7) {
                if (this.data_history.current_page <= 4) {
                    return this.data_history.current_page === n ? "primary" : ""
                } else if (
                    this.data_history.current_page ==
                    this.data_history.last_page
                ) {
                    return n === 7 ? "primary" : ""
                } else if (
                    this.data_history.current_page ==
                    this.data_history.last_page - 1
                ) {
                    return n === 6 ? "primary" : ""
                } else if (
                    this.data_history.current_page ==
                    this.data_history.last_page - 2
                ) {
                    return n === 5 ? "primary" : ""
                } else {
                    return n === 4 ? "primary" : ""
                }
            } else {
                return this.data_history.current_page === n ? "primary" : ""
            }
        },
        page_num_show(n) {
            let page = n
            if (this.page_count == 7) {
                let chk2 = 0
                let chk3 = 0
                let chk4 = 0
                let chk5 = 0
                let chk6 = 0
                if (this.data.current_page == 1) {
                    chk2 = 2
                    chk3 = 3
                    chk4 = 4
                    chk5 = "..."
                    chk6 = this.data.last_page - 1
                } else if (this.data.current_page == this.data.last_page) {
                    chk2 = 2
                    chk3 = "..."
                    chk4 = this.data.last_page - 3
                    chk5 = this.data.last_page - 2
                    chk6 = this.data.last_page - 1
                } else if (this.data.current_page == 2) {
                    chk2 = 2
                    chk3 = 3
                    chk4 = 4
                    chk5 = "..."
                    chk6 = this.data.last_page - 1
                } else if (this.data.current_page == this.data.last_page - 1) {
                    chk2 = 2
                    chk3 = "..."
                    chk4 = this.data.last_page - 3
                    chk5 = this.data.last_page - 2
                    chk6 = this.data.last_page - 1
                } else if (this.data.current_page == 3) {
                    chk2 = 2
                    chk3 = 3
                    chk4 = 4
                    chk5 = "..."
                    chk6 = this.data.last_page - 1
                } else if (this.data.current_page == this.data.last_page - 2) {
                    chk2 = 2
                    chk3 = "..."
                    chk4 = this.data.last_page - 3
                    chk5 = this.data.last_page - 2
                    chk6 = this.data.last_page - 1
                } else {
                    chk2 = "..."
                    chk3 = this.data.current_page - 1
                    chk4 = this.data.current_page
                    chk5 = this.data.current_page + 1
                    chk6 = "..."
                }

                n === 1 ? (page = 1) : ""
                n === 2 ? (page = chk2) : ""
                n === 3 ? (page = chk3) : ""
                n === 4 ? (page = chk4) : ""
                n === 5 ? (page = chk5) : ""
                n === 6 ? (page = chk6) : ""
                n === 7 ? (page = this.data.last_page) : ""
            } else {
                n === 1 ? (page = 1) : ""
                n === 2 ? (page = 2) : ""
                n === 3 ? (page = 3) : ""
                n === 4 ? (page = 4) : ""
                n === 5 ? (page = 5) : ""
                n === 6 ? (page = 6) : ""
            }
            return page
        },
        page_num_showreceiveitem(n) {
            let page = n
            if (this.page_countreceiveitem == 7) {
                let chk2 = 0
                let chk3 = 0
                let chk4 = 0
                let chk5 = 0
                let chk6 = 0
                if (this.dataviewpending.current_page == 1) {
                    chk2 = 2
                    chk3 = 3
                    chk4 = 4
                    chk5 = "..."
                    chk6 = this.dataviewpending.last_page - 1
                } else if (
                    this.dataviewpending.current_page ==
                    this.dataviewpending.last_page
                ) {
                    chk2 = 2
                    chk3 = "..."
                    chk4 = this.dataviewpending.last_page - 3
                    chk5 = this.dataviewpending.last_page - 2
                    chk6 = this.dataviewpending.last_page - 1
                } else if (this.dataviewpending.current_page == 2) {
                    chk2 = 2
                    chk3 = 3
                    chk4 = 4
                    chk5 = "..."
                    chk6 = this.dataviewpending.last_page - 1
                } else if (
                    this.dataviewpending.current_page ==
                    this.dataviewpending.last_page - 1
                ) {
                    chk2 = 2
                    chk3 = "..."
                    chk4 = this.dataviewpending.last_page - 3
                    chk5 = this.dataviewpending.last_page - 2
                    chk6 = this.dataviewpending.last_page - 1
                } else if (this.dataviewpending.current_page == 3) {
                    chk2 = 2
                    chk3 = 3
                    chk4 = 4
                    chk5 = "..."
                    chk6 = this.dataviewpending.last_page - 1
                } else if (
                    this.dataviewpending.current_page ==
                    this.dataviewpending.last_page - 2
                ) {
                    chk2 = 2
                    chk3 = "..."
                    chk4 = this.dataviewpending.last_page - 3
                    chk5 = this.dataviewpending.last_page - 2
                    chk6 = this.dataviewpending.last_page - 1
                } else {
                    chk2 = "..."
                    chk3 = this.dataviewpending.current_page - 1
                    chk4 = this.dataviewpending.current_page
                    chk5 = this.dataviewpending.current_page + 1
                    chk6 = "..."
                }

                n === 1 ? (page = 1) : ""
                n === 2 ? (page = chk2) : ""
                n === 3 ? (page = chk3) : ""
                n === 4 ? (page = chk4) : ""
                n === 5 ? (page = chk5) : ""
                n === 6 ? (page = chk6) : ""
                n === 7 ? (page = this.dataviewpending.last_page) : ""
            } else {
                n === 1 ? (page = 1) : ""
                n === 2 ? (page = 2) : ""
                n === 3 ? (page = 3) : ""
                n === 4 ? (page = 4) : ""
                n === 5 ? (page = 5) : ""
                n === 6 ? (page = 6) : ""
            }
            return page
        },
        page_num_showreceivepacking(n) {
            let page = n
            if (this.page_countreceivepacking == 7) {
                let chk2 = 0
                let chk3 = 0
                let chk4 = 0
                let chk5 = 0
                let chk6 = 0
                if (this.dataviewpending.current_page == 1) {
                    chk2 = 2
                    chk3 = 3
                    chk4 = 4
                    chk5 = "..."
                    chk6 = this.dataviewpending.last_page - 1
                } else if (
                    this.dataviewpending.current_page ==
                    this.dataviewpending.last_page
                ) {
                    chk2 = 2
                    chk3 = "..."
                    chk4 = this.dataviewpending.last_page - 3
                    chk5 = this.dataviewpending.last_page - 2
                    chk6 = this.dataviewpending.last_page - 1
                } else if (this.dataviewpending.current_page == 2) {
                    chk2 = 2
                    chk3 = 3
                    chk4 = 4
                    chk5 = "..."
                    chk6 = this.dataviewpending.last_page - 1
                } else if (
                    this.dataviewpending.current_page ==
                    this.dataviewpending.last_page - 1
                ) {
                    chk2 = 2
                    chk3 = "..."
                    chk4 = this.dataviewpending.last_page - 3
                    chk5 = this.dataviewpending.last_page - 2
                    chk6 = this.dataviewpending.last_page - 1
                } else if (this.dataviewpending.current_page == 3) {
                    chk2 = 2
                    chk3 = 3
                    chk4 = 4
                    chk5 = "..."
                    chk6 = this.dataviewpending.last_page - 1
                } else if (
                    this.dataviewpending.current_page ==
                    this.dataviewpending.last_page - 2
                ) {
                    chk2 = 2
                    chk3 = "..."
                    chk4 = this.dataviewpending.last_page - 3
                    chk5 = this.dataviewpending.last_page - 2
                    chk6 = this.dataviewpending.last_page - 1
                } else {
                    chk2 = "..."
                    chk3 = this.dataviewpending.current_page - 1
                    chk4 = this.dataviewpending.current_page
                    chk5 = this.dataviewpending.current_page + 1
                    chk6 = "..."
                }

                n === 1 ? (page = 1) : ""
                n === 2 ? (page = chk2) : ""
                n === 3 ? (page = chk3) : ""
                n === 4 ? (page = chk4) : ""
                n === 5 ? (page = chk5) : ""
                n === 6 ? (page = chk6) : ""
                n === 7 ? (page = this.dataviewpending.last_page) : ""
            } else {
                n === 1 ? (page = 1) : ""
                n === 2 ? (page = 2) : ""
                n === 3 ? (page = 3) : ""
                n === 4 ? (page = 4) : ""
                n === 5 ? (page = 5) : ""
                n === 6 ? (page = 6) : ""
            }
            return page
        },
        page_num_showhistory(n) {
            let page = n
            if (this.page_counthistory == 7) {
                let chk2 = 0
                let chk3 = 0
                let chk4 = 0
                let chk5 = 0
                let chk6 = 0
                if (this.data_history.current_page == 1) {
                    chk2 = 2
                    chk3 = 3
                    chk4 = 4
                    chk5 = "..."
                    chk6 = this.data_history.last_page - 1
                } else if (
                    this.data_history.current_page ==
                    this.data_history.last_page
                ) {
                    chk2 = 2
                    chk3 = "..."
                    chk4 = this.data_history.last_page - 3
                    chk5 = this.data_history.last_page - 2
                    chk6 = this.data_history.last_page - 1
                } else if (this.data_history.current_page == 2) {
                    chk2 = 2
                    chk3 = 3
                    chk4 = 4
                    chk5 = "..."
                    chk6 = this.data_history.last_page - 1
                } else if (
                    this.data_history.current_page ==
                    this.data_history.last_page - 1
                ) {
                    chk2 = 2
                    chk3 = "..."
                    chk4 = this.data_history.last_page - 3
                    chk5 = this.data_history.last_page - 2
                    chk6 = this.data_history.last_page - 1
                } else if (this.data_history.current_page == 3) {
                    chk2 = 2
                    chk3 = 3
                    chk4 = 4
                    chk5 = "..."
                    chk6 = this.data_history.last_page - 1
                } else if (
                    this.data_history.current_page ==
                    this.data_history.last_page - 2
                ) {
                    chk2 = 2
                    chk3 = "..."
                    chk4 = this.data_history.last_page - 3
                    chk5 = this.data_history.last_page - 2
                    chk6 = this.data_history.last_page - 1
                } else {
                    chk2 = "..."
                    chk3 = this.data_history.current_page - 1
                    chk4 = this.data_history.current_page
                    chk5 = this.data_history.current_page + 1
                    chk6 = "..."
                }

                n === 1 ? (page = 1) : ""
                n === 2 ? (page = chk2) : ""
                n === 3 ? (page = chk3) : ""
                n === 4 ? (page = chk4) : ""
                n === 5 ? (page = chk5) : ""
                n === 6 ? (page = chk6) : ""
                n === 7 ? (page = this.data_history.last_page) : ""
            } else {
                n === 1 ? (page = 1) : ""
                n === 2 ? (page = 2) : ""
                n === 3 ? (page = 3) : ""
                n === 4 ? (page = 4) : ""
                n === 5 ? (page = 5) : ""
                n === 6 ? (page = 6) : ""
            }
            return page
        },
        page_num_showsentpacking(n) {
            let page = n
            if (this.page_countsentpacking == 7) {
                let chk2 = 0
                let chk3 = 0
                let chk4 = 0
                let chk5 = 0
                let chk6 = 0
                if (this.dataviewpending.current_page == 1) {
                    chk2 = 2
                    chk3 = 3
                    chk4 = 4
                    chk5 = "..."
                    chk6 = this.dataviewpending.last_page - 1
                } else if (
                    this.dataviewpending.current_page ==
                    this.dataviewpending.last_page
                ) {
                    chk2 = 2
                    chk3 = "..."
                    chk4 = this.dataviewpending.last_page - 3
                    chk5 = this.dataviewpending.last_page - 2
                    chk6 = this.dataviewpending.last_page - 1
                } else if (this.dataviewpending.current_page == 2) {
                    chk2 = 2
                    chk3 = 3
                    chk4 = 4
                    chk5 = "..."
                    chk6 = this.dataviewpending.last_page - 1
                } else if (
                    this.dataviewpending.current_page ==
                    this.dataviewpending.last_page - 1
                ) {
                    chk2 = 2
                    chk3 = "..."
                    chk4 = this.dataviewpending.last_page - 3
                    chk5 = this.dataviewpending.last_page - 2
                    chk6 = this.dataviewpending.last_page - 1
                } else if (this.dataviewpending.current_page == 3) {
                    chk2 = 2
                    chk3 = 3
                    chk4 = 4
                    chk5 = "..."
                    chk6 = this.dataviewpending.last_page - 1
                } else if (
                    this.dataviewpending.current_page ==
                    this.dataviewpending.last_page - 2
                ) {
                    chk2 = 2
                    chk3 = "..."
                    chk4 = this.dataviewpending.last_page - 3
                    chk5 = this.dataviewpending.last_page - 2
                    chk6 = this.dataviewpending.last_page - 1
                } else {
                    chk2 = "..."
                    chk3 = this.dataviewpending.current_page - 1
                    chk4 = this.dataviewpending.current_page
                    chk5 = this.dataviewpending.current_page + 1
                    chk6 = "..."
                }

                n === 1 ? (page = 1) : ""
                n === 2 ? (page = chk2) : ""
                n === 3 ? (page = chk3) : ""
                n === 4 ? (page = chk4) : ""
                n === 5 ? (page = chk5) : ""
                n === 6 ? (page = chk6) : ""
                n === 7 ? (page = this.dataviewpending.last_page) : ""
            } else {
                n === 1 ? (page = 1) : ""
                n === 2 ? (page = 2) : ""
                n === 3 ? (page = 3) : ""
                n === 4 ? (page = 4) : ""
                n === 5 ? (page = 5) : ""
                n === 6 ? (page = 6) : ""
            }
            return page
        },

        ...mapMutations(["mutateIsLoading"]),
        ...mapMutations(["mutatesnackbar"]),

        toggle(i) {
            if (this.add_newitems[i].branch.length !== this.databranch.length) {
                this.add_newitems[i].icon = "mdi-close-box"
                this.add_newitems[i].branch = []
                for (let a = 0; a < this.databranch.length; a++) {
                    this.add_newitems[i].branch.push(
                        this.databranch[a].branch_id
                    )
                }
            } else {
                this.add_newitems[i].icon = "mdi-checkbox-blank-outline"
                this.add_newitems[i].branch = []
            }
        },
        chkNum() {
            if (event.keyCode < 48 || event.keyCode > 57) {
                event.returnValue = false
            }
        },
        deleteItem(item) {
            const idx = item.detail_id
            this.$swal({
                title: "Confirm delete this item ?",
                text: "",
                icon: "warning",
                buttons: true,
                dangerMode: true,
            }).then((del) => {
                if (del) {
                    const url = `${process.env.VUE_APP_ROOT_API}/api/logistics/packing-request/delete`
                    // console.log(url);
                    try {
                        const { data } = axios.get(url + "/" + idx)
                    } catch (error) {
                        console.log(error)
                    }
                    this.getAjax()
                }
            })
        },
        all() {
            this.panel = [...Array(this.items).keys()].map((k, i) => i)
        },
        // Reset the panel
        none() {
            this.panel = []
        },
        async save() {
            this.mutateIsLoading()
            const options = {
                headers: {
                    Authorization: "Bearer " + localStorage.token,
                },
            }
            const url = `${process.env.VUE_APP_ROOT_API}/api/happy-call/pass-to-closecase`
            // console.log(item);
            var sent = {
                case: this.checked,
            }
            // console.log(sent);
            try {
                const { data } = await axios.post(url, sent, options)
                this.mutateIsLoading()
                this.dialog = false
                this.getAjax()
            } catch (error) {
                console.log(error)
            }
        },
        async getBranch() {
            const options = {
                headers: {
                    Authorization: "Bearer " + localStorage.token,
                },
            }
            const url = `${process.env.VUE_APP_ROOT_API}/api/logistics/get-branch`
            try {
                // this.mutateIsLoading()
                const { data } = await axios.get(url, options)

                this.datateam = data.team
                this.databranch = data.branchs
                // console.log(data, "datateam");
                // this.mutateIsLoading()
            } catch (error) {
                console.log(error)
            }
        },
        async getType() {
            const url1 = `${process.env.VUE_APP_ROOT_API}/api/logistics/packing-type`

            try {
                // this.mutateIsLoading()
                const { data } = await axios.get(url1)
                this.datatype = data
                // this.mutateIsLoading()
            } catch (error) {
                console.log(error)
            }
        },

        showsummary(project) {
            this.data = []
            this.project = project
            if (this.project == "ViewOwnerItem") {
                this.header = "headersviewowneritem"
                this.getAjax()
            } else if (this.project == "NONHP Issue/Transfer") {
                this.header = "headersnonhp"
                this.getissuetransfer()
                this.all()
            } else if (this.project == "View Send List") {
                this.header = "headersviewsentlist"
                this.getAjax()
            } else if (this.project == "View Receive List") {
                this.header = "headersviewreceivelist"
                this.getAjax()
            }
        },
        cancelRow() {
            this.add_newitems.splice(this.add_newitem)
            this.add_newitems.push({
                branch: [],
                team: "",
                type: "",
                description: "",
                qty: "1",
                company: "ACACIA",
                icon: "mdi-checkbox-blank-outline",
                likesAllFruit: false,
                likesSomeFruit: false,
            })
            this.stateadd = false
        },
        addNewRow() {
            this.add_newitems.push({
                branch: [],
                team: "",
                type: "",
                description: "",
                qty: "1",
                company: "ACACIA",
                icon: "mdi-checkbox-blank-outline",
                likesAllFruit: false,
                likesSomeFruit: false,
            })
        },
        deleteRow(index, add_newitem) {
            var idx = this.add_newitems.indexOf(add_newitem)
            // console.log(idx, index);
            if (idx > -1) {
                this.add_newitems.splice(idx, 1)
            }
        },

        async editItem(item) {
            this.edit = 1
            this.editedIndex = item.detail_id
            this.stateadd = 1
            const editteam = ""
            const url = `${process.env.VUE_APP_ROOT_API}/api/logistics/packing-request`
            const options = {
                headers: {
                    Authorization: "Bearer " + localStorage.token,
                },
            }
            try {
                this.mutateIsLoading()
                const { data } = await axios.get(
                    url + "/" + this.editedIndex,
                    options
                )
                this.add_newitems = []

                if (this.datateam != undefined) {
                    this.datateam.map((each) => {
                        if (each.team_name == item.team_name) {
                            this.editteam = each.team_id
                        }
                    })
                }

                this.add_newitems.push({
                    branch: [data.branch_id],
                    team: this.editteam,
                    type: data.type_id,
                    description: data.description,
                    company: data.company,
                })

                this.dialogform = true
                this.mutateIsLoading()
            } catch (error) {
                console.log(error)
            }
        },

        close() {
            this.dialog = false
        },
        editpackingrequest() {
            this.mutatesnackbar()

            this.sendAjax(this.add_newitems, -1)
            this.close()
            if (this.snackbar === true) {
                setTimeout(() => {
                    this.mutatesnackbar()
                    this.snackbar
                }, 2000)
                this.add_newitems = [
                    {
                        branch: [],
                        team: "",
                        type: "",
                        description: "",
                        qty: "1",
                        company: "ACACIA",
                        icon: "mdi-checkbox-blank-outline",
                        likesAllFruit: false,
                        likesSomeFruit: false,
                    },
                ]
                this.stateadd = 0
                this.getAjax()
            }
        },

        savepackingrequest(value) {
            for (let i = 0; i < value; i++) {
                if (
                    this.add_newitems[i].branch == "" &&
                    this.team_name !== "SVC" &&
                    this.team_name !== "ONSITE" &&
                    this.role_name !== "Admin Hub"
                ) {
                    this.$swal(
                        "กรุณาเลือก Site ด้วยครับ ตรงตำแหน่ง" + value,
                        "Please Choose Site",
                        "info"
                    )

                    exit()
                }
            }

            this.add_newitems1 = {
                add_newitems: [],
            }
            if (
                this.team_name != "SVC" &&
                this.team_name !== "ONSITE" &&
                this.role_name !== "Admin Hub"
            ) {
                this.add_newitems.map((each) => {
                    var sent1 = {
                        branch: each.branch,
                        team: each.team,
                        type: each.type,
                        description: each.description,
                        qty: each.qty,
                        company: each.company,
                    }

                    this.add_newitems1.add_newitems.push(sent1)
                })
            } else {
                this.add_newitems.map((each) => {
                    var branch1 = ["1"]
                    var sent1 = {
                        branch: branch1,
                        team: each.team,
                        type: each.type,
                        description: each.description,
                        qty: each.qty,
                        company: each.company,
                    }

                    this.add_newitems1.add_newitems.push(sent1)
                })
            }
            this.mutatesnackbar()
            this.sendAjax(this.add_newitems1.add_newitems, 1)
            this.close()
            if (this.snackbar === true) {
                setTimeout(() => {
                    this.mutatesnackbar()
                    this.snackbar
                }, 2000)
                this.add_newitems = [
                    {
                        branch: [],
                        team: "",
                        type: "",
                        description: "",
                        qty: "1",
                        company: "ACACIA",
                        icon: "mdi-checkbox-blank-outline",
                        likesAllFruit: false,
                        likesSomeFruit: false,
                    },
                ]
                this.stateadd = 0
            }
        },

        async sendAjax(item, idx) {
            // console.log(item, "ddsd");
            this.mutateIsLoading()
            if (idx == 1) {
                const url = `${process.env.VUE_APP_ROOT_API}/api/logistics/packing-request-save`

                const options = {
                    headers: {
                        Authorization: "Bearer " + localStorage.token,
                    },
                }
                var sent = {
                    add_newitems: item,
                }
                try {
                    const { data } = await axios.post(url, sent, options)

                    this.mutateIsLoading()
                    this.getAjax()
                } catch (error) {
                    console.log(error)
                }
            } else if (idx == -1) {
                const url = `${process.env.VUE_APP_ROOT_API}/api/logistics/packing-request/edit`
                const id = this.editedIndex
                const options = {
                    headers: {
                        Authorization: "Bearer " + localStorage.token,
                    },
                }

                var sentedit = {
                    branch: this.add_newitems[0].branch[0],
                    team: this.add_newitems[0].team,
                    type: this.add_newitems[0].type,
                    description: this.add_newitems[0].description,
                    company: this.add_newitems[0].company,
                }

                try {
                    const { data } = await axios.post(
                        url + "/" + id,
                        sentedit,
                        options
                    )
                    this.mutateIsLoading()
                    this.getAjax()
                } catch (error) {
                    console.log(error)
                }
            }
        },

        async getAjax() {
            this.mutateIsLoading()
            this.activetab = "Viewowner"
            const url = `${process.env.VUE_APP_ROOT_API}/api/logistics/packing-request`
            const options = {
                headers: {
                    Authorization: "Bearer " + localStorage.token,
                },
            }
            try {
                const { data } = await axios.post(
                    url,
                    { searchtext: this.search },
                    options
                )
                // console.log(data, "sadsad");
                this.data = data
                this.mutateIsLoading()
                this.page_total = data.last_page
                this.page_total < 7
                    ? (this.page_count = this.page_total)
                    : (this.page_count = 7)
                // console.log(this.data, "zzz");
            } catch (error) {
                console.log(error)
            }
        },
        async getissuetransfer() {
            const url = `${process.env.VUE_APP_ROOT_API}/api/logistics/view-issue-transfer`
            const options = {
                headers: {
                    Authorization: "Bearer " + localStorage.token,
                },
            }
            try {
                this.mutateIsLoading()
                const { data } = await axios.get(url, options)
                this.dataissuetransfer = data
                // console.log(data, "data");
                this.mutateIsLoading()
            } catch (error) {
                console.log(error)
            }
        },
        opendialog() {
            this.edit = 0
            if (this.stateadd == 0) {
                this.stateadd = 1
            } else {
                this.stateadd = 0
            }
            this.add_newitems = [...this.add_newitems_template]
            this.dialogform = true
        },
    },
}
</script>
<style scoped>
.wms-title:before {
    left: 130px;
}

.wms-title:before {
    content: "";
    position: absolute;
    width: 150px;
    height: 3px;
    background: #1ba5ea;
}
.wms-title:after {
    content: "";
    position: absolute;
    width: 200px;
    height: 3px;
    background: #1ba5ea;
}
.wms-title:after {
    margin-top: 70px;
    right: 100px;
}
.basil {
    background-color: #fffbe6 !important;
}
.basil--text {
    color: #356859 !important;
}
.widthtextfield {
    padding: 0 12px;
    width: 200px;
}
.widthtextfieldqty {
    padding: 0 12px;
    width: 70px;
}
@media screen and (min-width: 200px) {
    .btnCancel {
        margin-left: 20px;
    }
    .btnSave {
        margin-left: 20px;
    }
}
@media screen and (min-width: 768px) {
    .btnCancel {
        margin-left: 40px;
    }
    .btnSave {
        margin-left: 20px;
    }
}
@media screen and (min-width: 1024px) {
    .btnCancel {
        margin-left: 0px;
    }
    .btnSave {
        margin-left: 40px;
    }
}
@media screen and (min-width: 1366px) {
    .btnCancel {
        margin-left: 20px;
    }
    .btnSave {
        margin-left: 60px;
    }
}
@media screen and (min-width: 1280px) {
    .btnCancel {
        margin-left: 20px;
    }
    .btnSave {
        margin-left: 60px;
    }
}
.v-application--is-ltr .v-expansion-panel-header {
    text-align: left;
    background: rgb(1, 112, 247);
    color: #ffffff;
    font-weight: bold;
    text-shadow: 0px 0px 10px rgba(189, 250, 250, 0.5);
}
.v-expansion-panel--active > .v-expansion-panel-header {
    min-height: 64px;
    background: rgb(1, 112, 247);
    color: #ffffff;
    font-weight: bold;
    text-shadow: 0px 0px 10px rgba(189, 250, 250, 0.5);
}
.v-expansion-panels:not(.v-expansion-panels--accordion):not(.v-expansion-panels--tile)
    > .v-expansion-panel--next-active
    .v-expansion-panel-header {
    border-bottom-left-radius: inherit;

    border-bottom-right-radius: inherit;
    background: rgb(1, 112, 247);
    color: #ffffff;
    text-shadow: 0px 0px 10px rgba(189, 250, 250, 0.5);
    font-weight: bold;
}
.fontglow {
    color: #edf5f7;
    text-shadow: 0px 0px 10px rgba(189, 250, 250, 0.5);
}
.v-select.v-input--dense .v-select__selection--comma {
    margin: 5px 4px 3px 0;
    color: brown;
}
.table-inv1 td {
    border: 1px solid black;
}
.table-inv1 th {
    border: 1px solid black;
    font-size: 10px;
}
.custom-loader {
    animation: loader 1s infinite;
    display: flex;
}
@-moz-keyframes loader {
    from {
        transform: rotate(0);
    }
    to {
        transform: rotate(360deg);
    }
}
@-webkit-keyframes loader {
    from {
        transform: rotate(0);
    }
    to {
        transform: rotate(360deg);
    }
}
@-o-keyframes loader {
    from {
        transform: rotate(0);
    }
    to {
        transform: rotate(360deg);
    }
}
@keyframes loader {
    from {
        transform: rotate(0);
    }
    to {
        transform: rotate(360deg);
    }
}
</style>
